module.exports = __webpack_public_path__ + "img/0.885d9a7f.png";